import { format } from 'd3-format';

import './styles/graphic.scss';
import { numberWithCommas } from './utils/helpers';
import './utils/polyfills.js';

export default function (props, container, isMobile) {
  const {
    data,
    initialWidth,
    initialHeight,
    width,
    height,
    x,
    y,
    xAxis,
    yAxis,
    margins,
  } = props;

  const yTicks = isMobile ? 5 : 5;
  const fmtComma = format(',');
  const fmtSI = format('.1s');

  /** SET WEEKLY * */
  const selectedDate = 'May-2';
  // need to add the old selected date to this each week
  const selectDates = [selectedDate, '2020-04-25', '2020-04-18', '2020-04-11', '2020-04-04', '2020-03-28', '2020-03-21'];
  // from spreadsheet
  const sumClaims = '33.5 million claims';
  // update week
  const sumClaimsContext = 'over the last seven weeks';
  const claimsPrevious = 'last week (April 26 - May 2)';

  const ticksMobi = ['2019', '2020', selectedDate];
  const ticksDesk = ['2019', '2020', selectedDate];

  const svg = container.append('svg')
    .attr('width', initialWidth)
    .attr('height', initialHeight);

  const g = svg.append('g')
    .attr('transform', `translate(${[margins.left, margins.top]})`);

  const xGrid = g.append('g')
    .attr('class', 'x grid')
    .attr('transform', `translate(${[0, height]})`)
    .call(xAxis(x)
      .tickValues(isMobile ? ticksMobi : ticksDesk));
  // .tickFormat(d => (isMobile ? `\u0027${String(d).substring(2, 4)}` : `\u0027${String(d).substring(2, 4)}`)));

  xGrid.selectAll('text')
    .attr('y', 10)
    .filter(d => d === selectedDate)
    .text(d => d.replace(/-/g, ' '));

  const yGrid = g.append('g')
    .attr('class', 'y grid')
    .call(yAxis(y)
      .ticks(yTicks)
      .tickSize(-width)
      .tickFormat(d => (isMobile
        ? (Math.abs(d) > 999
          ? fmtSI(d).toUpperCase()
          : fmtComma(d)
        )
        : (Math.abs(d) > 9999
          ? fmtSI(d).toUpperCase()
          : fmtComma(d)
        ))));

  yGrid.selectAll('text')
    .attr('x', -5)
    .filter(d => d === 0)
    .remove(); // hide zero

  const group = g.append('g')
    .attr('class', 'data');

  // const recessions = group.append('g')
  //  .attr('class', 'recessions');

  const bars = group.append('g')
    .attr('class', 'bars');

  const labels = group.append('g')
    .attr('class', 'labels');

  const bar = bars.selectAll('.bar')
    .data(data)
    .enter().append('g')
    .attr('class', 'bar')
    .attr('role', 'list')
    .attr('transform', d => `translate(${[x(d.label) + 0, y(d.amt < 0 ? 0 : d.amt)]})`);

  bar.append('title')
    .text(d => `${d.label} (${d.amt})`);

  bar.append('rect')
    .attr('class', d => `data-${d.label}`)
    .attr('width', x.bandwidth())
    .attr('height', d => Math.abs(y(d.amt) - y(0)));

  labels.append('text')
    .attr('class', 'label-2020-focus')
    // .attr('transform', `translate(${[x(selectedDate) + 3, y(data.find(v => v.label === selectedDate).amt)]})`)
    .attr('transform', isMobile ? `translate(${[width / 2, 65]})` : `translate(${[width / 2, 81]})`)
    .attr('text-anchor', 'middle')
    .text(`${numberWithCommas(data.find(v => v.label === selectedDate).amt)} claims`)
    .append('tspan')
    .text(claimsPrevious)
    .attr('x', 0)
    .attr('dy', isMobile ? +16 : +20);

  labels.append('text')
    .attr('class', 'label-2020-focus')
    // .attr('transform', `translate(${[x(selectedDate) + 3, y(data.find(v => v.label === selectedDate).amt)]})`)
    .attr('transform', isMobile ? `translate(${[width / 2, 110]})` : `translate(${[width / 2, 138]})`)
    .attr('text-anchor', 'middle')
    .text(sumClaims)
    .append('tspan')
    .text(sumClaimsContext)
    .attr('x', 0)
    .attr('dy', isMobile ? +16 : +20);
}
